const STORAGE_KEYS = {
    MCORE_CONFIG: 'mcoreConfig',
    BACKSTAGE_CONFIG: 'backstageConfig',
    TRANSLATIONS: 'translations',
    DEVICE_CONFIG: 'deviceConfig',
    LOGGED_USER_OBJECT: 'loggedUserObject',
    BACKSTAGE_MENUS: 'backstageMenus',
    API_CACHE: {
        CHANNELS_BRIEF: 'channelsBriefCache',
        CHANNELS: 'channelsCache',
        EPG: 'epgCache'
    },
    STRING_MODIFICATIONS: 'stringModifications',
    PLAYER_PRESETS: {
        BRIGHTNESS: 'playerBrightness'
    },
    PIN_BLOCKED: 'pinBlocked',
    MY_SUBSCRIPTIONS: 'mySubscriptions',
    DATA_SAVER: 'dataSaver'
};

export default STORAGE_KEYS;
